<template>
  <LayoutTriggerCard
    :title="title"
    :subtitle="subtitle"
    :is-configured="isConfigured"
    :is-configure-active="isConfigureActive"
    :selected="selected"
    :show-start-button="false"
    @delete="onDeleteClick"
    @configure="onConfigureClick"
    @start-workflow="onStartWorkflowClick"
  >
    <template #icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="white"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.49 9.38C11.92 8.16 11.66 6.74 10.68 5.76C9.57 4.65 7.89 4.46 6.58 5.17L8.93 7.52L7.52 8.93L5.17 6.58C4.46 7.9 4.65 9.57 5.76 10.68C6.74 11.66 8.16 11.92 9.38 11.49L12.79 14.9C12.99 15.1 13.3 15.1 13.5 14.9L14.9 13.5C15.1 13.3 15.1 12.99 14.9 12.79L11.49 9.38Z" fill="white"/>
      </svg>
    </template>

    <template #content>
      <div class="manual-trigger-info">
        <span class="info-text">Workflow will be triggered immediately upon assignment to a patient.</span>
      </div>
    </template>
  </LayoutTriggerCard>
</template>

<script>
import LayoutTriggerCard from './LayoutTriggerCard.vue';

export default {
  name: 'TriggerManual',
  components: {
    LayoutTriggerCard
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title() {
      return 'Manual';
    },
    subtitle() {
      return 'Manually triggered workflow (patient assignment)';
    },
    isConfigured() {
      return Boolean(this.data && this.data.configured);
    },
    isConfigureActive() {
      return true;
    }
  },
  mounted() {
    this.data.configured = true;
  },
  methods: {
    onDeleteClick() {
      this.$emit('delete');
    },
    onConfigureClick() {
      this.$emit('configure', { configured: true });
    },
    onStartWorkflowClick() {
      this.$emit('start-workflow');
    }
  }
};
</script>

<style scoped>
.manual-trigger-info {
  display: flex;
  gap: 6px;
  align-items: flex-start;
}

.info-text {
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;
  color: #374957;
}
</style>
